// extracted by mini-css-extract-plugin
export default {"footerBrand":"FooterBrand_footerBrand__9OVnd","tagline":"FooterBrand_tagline__lexLR"};